import { Component, Input } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { BibItem } from '../../providers/item/item';
import { AppState } from '../../config/state';

/**
 * Generated class for the CoBibSummaryComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-bib-summary',
  templateUrl: 'co-bib-summary.html',
  inputs: ['bibDetails', 'rating'],
})
export class CoBibSummaryComponent {
  @Input('bibDetails') bibDetails: BibItem;
  @Input('novelistDetails') novelistDetails: any;
  @Input('description') description: any;
  @Input('rating') rating: any;
  @Input('location') location: any;
  @Input('itemRecord') itemRecord: any;
  @Input('small') small: boolean;
  public updateObserver: Subject<Array<number>>;
  coverImage: string;
  errorImage: string;
  fullDescription: string;
  shortDescription: string;
  showFullDescription: boolean = false;
  charCount: number;
  constructor(private state: AppState) {
    setInterval(()=>this.update(), 500);//#TODO: fix this silly hack
  }
  public update(){
    if(this.updateObserver)this.updateObserver.next();
  }
  ngOnInit(): void {
    this.updateObserver = new Subject();
    // console.log(this.itemRecord);
    // console.log(this.bibDetails);
    if (this.description) this.description = this.description.replace(/<\/?[\w\s]*>|<.+[\W]>/g, "");
    this.fullDescription = this.description;
  }
  ngOnChanges(){
    let server = Math.floor(Math.random() * 9);
    this.errorImage = `http://covers${server}.communico.co/gen/cover?title=`+encodeURIComponent(this.bibDetails.title);
    // console.log(this.bibDetails);
    if (this.bibDetails.imageLinks && this.bibDetails.imageLinks.length > 0){
      this.coverImage = this.bibDetails.imageLinks[0].url;
    } else if (this.bibDetails.upcs && this.bibDetails.upcs.length>0 && this.bibDetails.upcs[0]) {
      this.coverImage = `https://${this.state.client.keyword}.libnet.info/getcover/${this.bibDetails.upcs[0]}`;
    } else if(this.bibDetails.isbns && this.bibDetails.isbns.length>0){
      if (this.bibDetails.isbns[0] == null && this.bibDetails.isbns.length > 1){
        this.coverImage = `https://${this.state.client.keyword}.libnet.info/getcover/${this.bibDetails.isbns[1]}`;
      } else {
        this.coverImage = `https://${this.state.client.keyword}.libnet.info/getcover/${this.bibDetails.isbns[0]}`;
      }
    }else if (this.bibDetails['cover']) {
        this.coverImage = this.bibDetails['cover'];
    }else{
      this.coverImage = this.errorImage;
    }
    if(this.description){
      // let descriptionBox = document.getElementById('descriptionBox');
      // let summaryContainerInfo = document.getElementById('summaryContainerInfo');
      // console.log(descriptionBox.getBoundingClientRect(), summaryContainerInfo.getBoundingClientRect());
      // if(this.description.length>this.charCount){
      //   this.fullDescription = this.description;
      //   this.description = this.fullDescription.substring(0, this.charCount)+'...';
      // }
      setTimeout(()=>this.checkDescriptionLength(), 100);
    }

  }
  // ngAfterViewChecked(): void {
  //   //Called after every check of the component's view. Applies to components only.
  //   //Add 'implements AfterViewChecked' to the class.
  //   let descriptionBox = document.getElementById('descriptionBox');
  //     let summaryContainerInfo = document.getElementById('summaryContainerInfo');
  //     console.log(descriptionBox.getBoundingClientRect(), summaryContainerInfo.getBoundingClientRect());
  // }
  ngAfterViewInit(): void {
    if (this.description){
      setTimeout(()=>this.checkDescriptionLength(), 100);
    }
  }

  checkDescriptionLength(): void {
    // let descriptionBox = document.getElementById('descriptionBox');
    let summaryContainerInfo = document.getElementById('summaryContainerInfo');
    let descHeightLines = (215) / 19;
    let descWidth = summaryContainerInfo.getBoundingClientRect().width / 7.7;
    this.charCount = Math.floor(descWidth * descHeightLines);
    // console.log(this.charCount, descriptionBox.getBoundingClientRect(), summaryContainerInfo.getBoundingClientRect());
    if(this.description && this.description.length>this.charCount){
      // this.fullDescription = this.description;
      this.shortDescription = this.description.substring(0, this.charCount)+'...';
    } else {
      this.showFullDescription = true;
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/co-bib-summary/co-bib-summary.ts